<div class="logout-page-loader" aria-live="polite" aria-busy="true">
  <app-loader></app-loader>
</div>
